import React, { Fragment } from 'react'
import { useRef, useState, useEffect, useCallback, useContext } from "react";
// import "../crmComponents/Addleads.css";
// import "../crmComponents/CRMList.css";
// import "../crmComponents/Contacts.css";
// import "../crmComponents/crmcontainer.css";
// import * as Icon from "react-bootstrap-icons";
// import { Row, Col, Form, Button, Breadcrumb } from "react-bootstrap";
// import LeadView from './LeadView';
import { useNavigate } from 'react-router-dom';
import ChatPage from "./ChatPage";
import ChatSetting from "./ChatSetting";
import { ChatText, CircleFill, Gear, PersonSquare } from 'react-bootstrap-icons';
import { Menu, Transition } from '@headlessui/react';
import { useSelector } from 'react-redux';
import { agentStatusUpdate } from '../../redux/actions/liveChatActions';
import { useDispatch } from 'react-redux';
// import Accounts from './Accounts';
// import AddAccounts from './AddAccounts';
// import AddLeads from './AddLeads';
// import LeadDetail from './LeadDetail';
// import LeadImport from './LeadImport';
// import LeadMapping from './LeadMapping';

const navigationLeft = [
    { name: 'Conversation', href: '/livechat/conversations/mine', icon: ChatText, current: "conversations" },
    { name: 'Leads', href: '/Lead-Management', icon: PersonSquare, current: "leads" },
    // { name: 'Reports', href: '/livechat/report', icon: Clipboard2Pulse, current: "unattended" },
    // { name: 'Help Center', href: '/livechat/center', icon: QuestionSquare, current: "unattended" },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const LiveChatContainer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = props.authToken;
  const pageName = window.location.pathname.slice(10);
  // agent status 
  const [agentStatus, setAgentStatus] = useState(1);
  const [agentStatusFlag, setAgentStatusFlag] = useState(1);
  const [assignAgentData, setAssignAgentData] = useState([]);
    // agent data
    
    const agent_status = useSelector(
        (state) => state.livechat.assign_list?.agent_status
    );
    
  const agentCaptureData = useSelector(
      (state) => state.assetLibrary.userData
  );
  
  useEffect(() => {
    props.pageTypeHandler("Live Chat");
  }, [])

  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
    if (uData?.data?.live_chat != true) {
        navigate(`/Chat-Ai`);
    }
  },[])

  // displaying the first two character of full name 
    const getChars = (str) => {
        if (str === "") {
        return;
        }
        const firstLetters = str
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
        return firstLetters;
    };
  
  const RightScreen = () => {
    if (props.subPageName === "mainChat") {
      return <ChatPage authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} />
    } else if (props.subPageName === "chatSetting") {
      return <ChatSetting authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} />
    }
    else {
      return
    }
  }
  
  return (
    <div>
      <div className="h-[100vh] flex pt-[4rem]">
        <div className="lg:inset-y-0 lg:left-0 lg:block lg:overflow-y-auto w-[3%] max-xl:w-[4%] bg-[#53c2d6]">
            <div className="py-2 h-full">
                {/* <div className="flex h-16 shrink-0 items-center justify-center">
                    <ChatText className="h-6 w-6 text-white border border-white p-1"/>
                </div> */}
                <nav className="flex flex-1 flex-col h-full ">
                    <ul className="flex flex-1 h-full flex-col items-center space-y-4">
                    {navigationLeft?.map((item) => (
                        <li key={item.name} className="cursor-pointer">
                            <div
                                onClick={() => {
                                    navigate(item.href);
                                }}
                                className={classNames(
                                window?.location?.pathname?.includes(item.href) ? 'bg-[#59adbc] text-white' : 'text-white hover:text-white hover:bg-[#59adbc]',
                                'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                )}
                            >
                                <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />
                                <span className="sr-only">{item.name}</span>
                            </div>
                        </li>
                    ))}
                    </ul>
                    <div className="mt-auto px-1">
                        <div className="cursor-pointer flex justify-center">
                            <span
                                onClick={() => {
                                    navigate("/livechat/setting/canned")
                                }}
                                className={classNames(
                                pageName === "setting" ? 'bg-[color-mix(in_srgb,var(--brand-primary)_20%,transparent)] text-white' : 'text-white hover:text-white hover:bg-[#59adbc]',
                                'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                )}
                            >
                                <Gear className="h-5 w-5" aria-hidden="true" />
                                <span className="sr-only">{"Settings"}</span>
                            </span>
                        </div>
                        <div className="cursor-pointer mt-2 flex justify-center">
                                <Menu as="div" className="relative inline-block text-left">
                                    <div>
                                        <Menu.Button className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 focus:outline-none">
                                        <span className="sr-only">Open options</span>
                                        <div
                                            className="bg-[var(--brand-primary)] relative text-center text-white p-1 w-7 h-7 rounded-full"
                                        >
                                            {getChars(agentCaptureData.first_name+ " " + agentCaptureData.last_name)}
                                            <CircleFill className={`${agent_status === 1 ? "text-green-700": agent_status == 3 ? "text-gray-500":"text-yellow-500"} border border-white h-2.5 w-2.5 rounded-full absolute right-[-1px] bottom-[-1px]`} />
                                        </div>
                                    </Menu.Button>
                                    </div>

                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="fixed left-8 bottom-10 z-10 mt-2 w-28 origin-top-right rounded-md shadow-xl bg-gray-100 ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div className="">
                                            <p className="text-[10px] cursor-default font-medium text-gray-700 px-2 py-1 border-b border-gray-300">Set yourself as</p>
                                            <Menu.Item>
                                            {({ active }) => (
                                                <span
                                                    onClick={() => {
                                                        dispatch(agentStatusUpdate(authToken, 1))       
                                                    }}
                                                    className={`${agent_status == 1 ? 'bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)]' : 'text-gray-900'} hover:bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)] px-2 py-1 text-[10px] flex items-center gap-1`}
                                                >
                                                    <CircleFill className="text-green-700 border border-white h-2.5 w-2.5 rounded-full"/>        
                                                    Online
                                                </span>
                                            )}
                                            </Menu.Item>
                                            <Menu.Item>
                                            {({ active }) => (
                                                <span
                                                    onClick={() => {
                                                        dispatch(agentStatusUpdate(authToken, 2))     
                                                    }}
                                                    className={`${agent_status == 2 ? 'bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)]' : 'text-gray-900'} hover:bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)] px-2 py-1 text-[10px] flex items-center gap-1`}
                                                >
                                                    <CircleFill className="text-yellow-500 border border-white h-2.5 w-2.5 rounded-full"/>        
                                                    Busy
                                                </span>
                                            )}
                                            </Menu.Item>
                                            <Menu.Item>
                                                <span
                                                    onClick={() => {
                                                        dispatch(agentStatusUpdate(authToken, 3))
                                                    }}
                                                    className={`${agent_status == 3 ? 'bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)]' : 'text-gray-900'} hover:bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)] px-2 py-1 text-[10px] flex items-center gap-1`}
                                                >
                                                    <CircleFill className="text-gray-500 border border-white h-2.5 w-2.5 rounded-full"/>        
                                                    Offline
                                                </span>
                                            </Menu.Item>
                                            {/* <div className="text-[10px] cursor-default  font-medium text-gray-700 px-2 py-1 flex justify-between border-t border-gray-300">
                                                <div className="flex items-center gap-1">
                                                    <InfoSquareFill className="cursor-pointer" title="Let the system automatically marks you offline when you aren't using the app or dashboard." />
                                                    <span>Mark offline automatically</span>
                                                </div>
                                                <Switch
                                                    checked={enabled}
                                                    onChange={setEnabled}
                                                    className={classNames(
                                                        enabled ? 'bg-[var(--brand-primary)]' : 'bg-gray-200',
                                                        'relative inline-flex h-2.5 w-6 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none'
                                                    )}
                                                    >
                                                    <span className="sr-only">Use setting</span>
                                                    <span
                                                        className={classNames(
                                                        enabled ? 'translate-x-3 -translate-y-0.5' : '-translate-x-0.5 -translate-y-0.5',
                                                        'pointer-events-none relative inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                                        )}
                                                    >
                                                        <span
                                                        className={classNames(
                                                            enabled ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in',
                                                            'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                        )}
                                                        aria-hidden="true"
                                                        >
                                                        <svg className="h-2 w-2 text-gray-400" fill="none" viewBox="0 0 12 12">
                                                            <path
                                                            d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                        </span>
                                                        <span
                                                        className={classNames(
                                                            enabled ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out',
                                                            'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                        )}
                                                        aria-hidden="true"
                                                        >
                                                        <svg className="h-2 w-2 text-[var(--brand-primary)]" fill="currentColor" viewBox="0 0 12 12">
                                                            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                        </svg>
                                                        </span>
                                                    </span>
                                                </Switch>
                                            </div> */}
                                        </div>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <RightScreen />
      </div>
    </div>
  )
}

export default LiveChatContainer
